var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ah-product-search-controls" },
    [
      _c("search-bar", {
        attrs: {
          inputLabel: _vm.inputLabel,
          inputPlaceholder: _vm.inputLabel,
          buttonLabel: _vm.submitLabel,
          onSubmit: _vm.handleSubmit
        }
      }),
      _vm._v(" "),
      _c("search-filters"),
      _vm._v(" "),
      _vm.showActiveFilters
        ? _c(
            "div",
            [
              _c("divider"),
              _vm._v(" "),
              _c("active-filters", {
                attrs: {
                  handleFilterRemove: _vm.handleFilterRemove,
                  handleClearFilters: _vm.handleClearFilters,
                  clearFiltersLabel: _vm.clearLabel
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("filter-drawer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }